module.exports = {
  API_URL: 'https://api.seremata.cl',
}